module.exports = __webpack_public_path__ + "img/dashboard.45e848cf.svg";